import { useState } from "react";
import { Link } from "react-router-dom";
import { AuthShell } from "@/pages/Login";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api, { apiErr } from "@/lib/api";
import { Loader2, ArrowLeft } from "lucide-react";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [done, setDone] = useState(false);
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault(); setLoading(true);
        try { await api.post("/auth/forgot-password", { email }); setDone(true); }
        catch (e) { setDone(true); } finally { setLoading(false); }
    };

    return (
        <AuthShell title="Reset password" subtitle="We'll generate a secure reset link">
            {done ? (
                <div className="space-y-4">
                    <p className="text-sm text-muted-foreground" data-testid="forgot-done">
                        If an account exists for <span className="text-foreground font-medium">{email}</span>, a reset link has been generated.
                        For this single-family-office app, the link is logged server-side by the administrator.
                    </p>
                    <Link to="/login"><Button variant="outline" className="w-full"><ArrowLeft className="w-4 h-4 mr-2" />Back to login</Button></Link>
                </div>
            ) : (
                <form onSubmit={submit} className="space-y-4">
                    <div className="space-y-1.5">
                        <Label>Email</Label>
                        <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
                            placeholder="you@example.com" data-testid="forgot-email-input" />
                    </div>
                    <Button type="submit" className="w-full" disabled={loading} data-testid="forgot-submit-btn">
                        {loading && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}Send reset link
                    </Button>
                    <Link to="/login" className="block text-center text-xs text-muted-foreground hover:text-foreground">Back to login</Link>
                </form>
            )}
        </AuthShell>
    );
}
